import { Component, inject } from '@angular/core';
import { SurveyTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SurveyTypeCreateDto,
  SurveyTypeDto,
  SurveyTypeExcelDownloadDto,
  SurveyTypeUpdateDto,
} from '../proxy/planning/dtos/survey-type';
import { SURVEYTYPE_CONFIG, SURVEYTYPE_FIELDS } from './survey-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-survey-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SurveyTypeService, ConfirmationService],
  templateUrl: './survey-type.html',
  styleUrl: './survey-type.scss',
})
export class SurveyType extends BaseCrudComponent<
  SurveyTypeDto,
  SurveyTypeCreateDto,
  SurveyTypeUpdateDto,
  SurveyTypeExcelDownloadDto
> {
  service = inject(SurveyTypeService);
  config = SURVEYTYPE_CONFIG;
  fields = SURVEYTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: SurveyTypeDto): SurveyTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SurveyType';
  }
}
